const APP_STORE_URL = '#';
const GOOGLE_PLAY_URL = '#';

export default function AppStoreButtons({ variant = 'dark', className = '' }) {
  const bg = variant === 'dark' ? 'bg-ink hover:bg-ink/85' : 'bg-white/10 hover:bg-white/20 border border-white/20';
  const text = variant === 'dark' ? 'text-white' : 'text-white';

  return (
    <div data-testid="app-store-buttons" className={`flex flex-wrap gap-3 ${className}`}>
      <a
        href={APP_STORE_URL}
        data-testid="app-store-button"
        aria-label="Download on the App Store"
        className={`inline-flex items-center gap-2.5 ${bg} ${text} rounded-xl px-5 py-3 transition-all duration-200 hover:scale-[1.02]`}
      >
        <i className="fab fa-apple text-2xl" aria-hidden="true"></i>
        <div className="text-left">
          <div className="text-[10px] opacity-75 leading-none font-body">Download on the</div>
          <div className="text-sm font-semibold leading-tight font-body">App Store</div>
        </div>
      </a>
      <a
        href={GOOGLE_PLAY_URL}
        data-testid="google-play-button"
        aria-label="Get it on Google Play"
        className={`inline-flex items-center gap-2.5 ${bg} ${text} rounded-xl px-5 py-3 transition-all duration-200 hover:scale-[1.02]`}
      >
        <i className="fab fa-google-play text-xl" aria-hidden="true"></i>
        <div className="text-left">
          <div className="text-[10px] opacity-75 leading-none font-body">Get it on</div>
          <div className="text-sm font-semibold leading-tight font-body">Google Play</div>
        </div>
      </a>
    </div>
  );
}
